export default "<p>\r\n  usuario works!\r\n</p>\r\n"